// removed by extract-text-webpack-plugin
module.exports = {"modal":"TvQuW5MuougpCFUpNxtbp","modalContent":"_23vRzpBcaVkaYBTcLd1O_R","symbol":"_3Kdl0PxmFQXRWQCkSIisia","popupHeader":"_3Tj09Zcfy-sUV6bB5xJUGf","content":"_24ED0y1gqMeNbV9l8ijnSh"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/Modal/Modal.styl
// module id = 744
// module chunks = 0